import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function OpenNewIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-open-new-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.19 17.27L17.47 20c-.7.7-.7 1.83 0 2.53.7.7 1.83.7 2.53 0l2.72-2.72 9.69-9.69v5.18c0 .99.8 1.79 1.79 1.79s1.79-.8 1.79-1.79V6.01c0-.07.01-.14.01-.21 0-.5-.2-.95-.53-1.27C35.15 4.2 34.7 4 34.2 4c-.07 0-.14.01-.21.01h-9.28c-.99 0-1.79.8-1.79 1.79s.8 1.79 1.79 1.79h5.16l-9.68 9.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.64 21.68v10.28c0 .38-.31.68-.68.68H8.04a.68.68 0 01-.68-.68V8.04c0-.38.31-.68.68-.68h10.28a4.438 4.438 0 01.1-3.35H8.04A4.027 4.027 0 004 8.04v23.92C4 34.19 5.81 36 8.04 36h23.92c2.23 0 4.04-1.81 4.04-4.04V21.58c-.55.24-1.16.38-1.8.38-.55 0-1.07-.1-1.56-.28z"
  })));
}